import type { ReactElement } from 'react';
import React from 'react';
import './no-results-placeholder.scss';

export default function NoResultsPlaceholder(): ReactElement {
  return (
    <tr className="no-results border">
      <td className="border-0">That search did not return any results, try refiltering</td>
    </tr>
  );
}
